import React, { useCallback } from 'react';
import RsvpButton from './RsvpButton';
import { Button, ButtonType } from 'mini-button';
import { getDefaultMiniColorScheme } from 'mini-color-utils/lib/colorUtils';
import { getOwaMiniCommonStrings } from 'owa-strings/owa-mini-common-strings';
import { getRsvpUnitIcon } from '../utils/getRsvpUnitIcon';
import { getRsvpUnitSubtitle } from '../utils/getRsvpUnitSubtitle';
import { getRsvpUnitTitle } from '../utils/getRsvpUnitTitle';
import { HubItem } from 'mini-hub';
import { HubItemStyleProps } from 'mini-hub/lib/components/HubItem.types';
import { MAIL_READING_PANE_VIEW } from 'data/lib/mini-app-constants/commonEventSourceConstants';
import { RsvpBarIcon } from './RsvpBarIcon';
import { RsvpContextObject } from '../utils/RsvpContextObject';
import { RsvpUnitProps } from '../schema/RsvpUnit.types';
import { useMoreEventDetailOperations } from 'mini-event-card/lib/hooks/useMoreEventDetailOperations';
import { VIEW_BUTTON_CLICKED } from 'data/lib/mini-app-constants/commonEventSignalConstants';

const styles = require('./RsvpUnit.scss');

const placeholderStyles = require('./CalendarIconAndSecondaryTextPlaceholderStyles.scss');

const RsvpActionBar: React.FC<RsvpUnitProps> = props => {
    const { item, originalMeetingMessage, showCalendarIconAndSecondaryTextPlaceholderUI } = props;

    const getAriaLabel = useCallback((computedAriaLabel: string) => computedAriaLabel, []);

    const { viewEventDetails } = useMoreEventDetailOperations();

    const strings = getOwaMiniCommonStrings();

    const { viewButtonLabel } = strings;
    const { IsOrganizer } = item;

    const onRenderAdditionalInfo = () =>
        IsOrganizer ? (
            <Button
                hasPopup
                text={viewButtonLabel}
                type={ButtonType.Inline}
                colorScheme={props.colorScheme || getDefaultMiniColorScheme()}
                onClick={() => {
                    viewEventDetails(item?.ItemId?.Id);
                    RsvpContextObject?.signal(
                        VIEW_BUTTON_CLICKED,
                        { isUIAction: true },
                        { actionSource: MAIL_READING_PANE_VIEW }
                    );
                }}
                ariaLabel={getAriaLabel(viewButtonLabel) || viewButtonLabel}
                onTouchStart={ev => {
                    ev.stopPropagation();
                }}
                onTouchEnd={ev => {
                    ev.stopPropagation();
                }}
                className={styles.viewEventButton}
            />
        ) : (
            <RsvpButton
                {...props}
                showRsvpResponseIfApplicable
                highlightRemoveButton
                getAriaLabel={getAriaLabel}
                deleteWithoutConfirmation
            />
        );

    // get all the icon details
    const { iconContainerStyles } = getRsvpUnitIcon(item);

    const onRenderIcon = () => <RsvpBarIcon item={item} />;

    const title = getRsvpUnitTitle(item);
    const subtitle = getRsvpUnitSubtitle(item, originalMeetingMessage);

    const unitStyles: HubItemStyleProps = {
        className: styles.container,
        primaryTextStyles: styles.unitTextContainer,
        secondaryTextStyles: showCalendarIconAndSecondaryTextPlaceholderUI
            ? placeholderStyles.secondaryText
            : styles.secondaryText,
        iconContainerStyles: showCalendarIconAndSecondaryTextPlaceholderUI
            ? placeholderStyles.iconContainer
            : iconContainerStyles,
    };

    return (
        <HubItem
            styles={unitStyles}
            onRenderIcon={showCalendarIconAndSecondaryTextPlaceholderUI ? null : onRenderIcon}
            onRenderAdditionalInfo={onRenderAdditionalInfo}
            primaryText={title}
            secondaryText={showCalendarIconAndSecondaryTextPlaceholderUI ? ' ' : subtitle}
            isHubItemNotTabbable
        />
    );
};

export default RsvpActionBar;
